import { View } from "react-native";
import { Text } from "react-native-paper";
import LottieView from "lottie-react-native";

import { LinkButton, Button, Modal } from "../../components";

type Props = {
  onEnroll?(): void;
  onClose(): void;
  visible: boolean;
};

export default function ActivityReviewSuccessModal({ onEnroll, onClose, visible }: Props) {
  return (
    <Modal {...{ visible, onDismiss: onClose, title: "" }}>
      <View className="pt-12 items-center justify-between px-10 py-6 bg-sky-white" testID="ActivityReviewSuccessModal">
        <View className="items-center">
          <View className="w-28 h-28">
            <LottieView style={{ flex: 1 }} autoPlay source={require("../../../assets/lottie-icons/verified.json")} />
          </View>
          <Text className="text-title-2 font-700 text-ink-darkest mt-8 text-center">Activity Confirmed</Text>
          <Text className="text-regular-normal font-400 text-ink-dark my-6 px-4 text-center">
            Thank you for reviewing this Member's activity request. You've helped a fellow PGA Member earn points toward
            deferred compensation.
          </Text>
          {onEnroll && (
            <View className="mt-12 items-center">
              <Text className="text-regular-tight font-700 text-ink-darker">Start earning points today.</Text>
              <LinkButton className="mt-4" onPress={onEnroll}>
                Enroll in Deferred Compensation
              </LinkButton>
            </View>
          )}
        </View>

        <View className="w-full mb-4 mt-8">
          <Button mode="secondary" onPress={onClose}>
            Close
          </Button>
        </View>
      </View>
    </Modal>
  );
}
